import React from "react";
import { CheckCircle2 } from "lucide-react"; // Icon library

const myths = [
  {
    id: 1,
    text: "Only candidates with exceptional IQ can clear UPSC. \n Reality: Consistency, discipline, and smart preparation matter more than raw intelligence.",
  },
  {
    id: 2,
    text: "UPSC requires covering every book ever written.\n Reality: Selective, smart study of standard sources + revision is the real key.",
  },
  {
    id: 3,
    text: "Only English medium students have an advantage.\n Reality: UPSC gives equal opportunity to all recognized languages; many toppers come from regional mediums.",
  },
  {
    id: 4,
    text: "Optional subject choice alone determines success.\n Reality: Any optional can yield high marks if prepared with depth and practice.",
  },
];

export default function Commen() {
  return (
    <section id="commonmyth" className="w-full bg-gray-50 py-12 px-6">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-indigo-900 mb-10">
          Common Myths About UPSC
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {myths.map((myth) => (
            <div
              key={myth.id}
              className="flex items-start bg-white rounded-xl p-5 shadow-sm border border-gray-200 hover:shadow-lg transition"
            >
              <CheckCircle2 className="text-red-600 w-6 h-6 mt-1 mr-3" />
              <div className="text-left">
                <h3 className="text-lg font-semibold text-red-700 mb-1">
                  Myth #{myth.id}
                </h3>
                <p className="text-gray-700 text-sm">{myth.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
